<div class="card" style="min-height: calc(100vh - 9rem)">
  <app-header titulo="Análises" descricao="Analises integradas"></app-header>

  <div class="mt-3">
    <p-table [value]="analises" size="small" dataKey="id" #dt [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" [globalFilterFields]="['id','empresa','identificador','lanHora','lanData','status']">
      <ng-template pTemplate="caption">
        <div class="flex">
          <p-button
            severity="info"
            label="Sincronizar"
            icon="pi pi-refresh"
            [loading]="loading"
            loadingIcon="pi pi-refresh"
            (onClick)="buscaAnalises()"/>

          <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:5%" pSortableColumn="identificador">Identificador<p-sortIcon field="identificador" /></th>
          <th style="width:5%">Empresa</th>
          <th style="width:5%" pSortableColumn="lanData">Data<p-sortIcon field="lanData" /></th>
          <th style="width:5%" pSortableColumn="lanHora">Apontamento<p-sortIcon field="lanHora" /></th>
          <th style="width:5%" pSortableColumn="dtCriado">Recebimento<p-sortIcon field="dtCriado" /></th>
          <th style="width:3%" pSortableColumn="status">Status
            <p-sortIcon field="status" />
            <p-columnFilter field="status" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">

              <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status" placeholder="Todos" [filter]="true"  optionValue="value" (onChange)="filter($event.value)" optionLabel="name">

                  <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                      <p-tag [severity]="getSeverity(option.name)">{{ option.name }}</p-tag>
                    </div>
                  </ng-template>

                </p-multiSelect>
              </ng-template>

              <ng-template pTemplate="clearfiltericon">

              </ng-template>
            </p-columnFilter>
          </th>
          <th style="width:12%" pSortableColumn="mensagem">Mensagem<p-sortIcon field="mensagem" /></th>
          <th style="width:10%" pSortableColumn="dtIntegradoPims">
            <p-sortIcon field="dtIntegradoPims" />
            Integrado
            <p-columnFilter type="date" field="date" display="" /></th>
          <th style="width:4%"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-analise>
        <tr>
          <td>{{ analise.identificador }}</td>
          <td>{{ analise.empresa }}</td>
          <td>{{ analise.lanData | date: 'dd/MM/yyyy' }}</td>
          <td>{{ analise.lanHora }}</td>
          <td>{{ analise.dtCriado | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td><p-tag [severity]="getSeverity(analise.status)">{{ analise.status }}</p-tag></td>
          <td>{{ analise.mensagem }}</td>
          <td>{{ analise.dtIntegradoPims | date: 'dd/MM/yyyy HH:mm' }}</td>

          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                pButton pRipple
                type="button"
                icon="pi pi-search"
                class="p-button-rounded p-button-text p-button-info"
                (click)="carregaAtributos(analise)">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    [(visible)]="formDialog"
    [style]="{ width: '70%' }"
    header="Atributos do registro"
    [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">

        <p-table [value]="analise.atributos" size="small" dataKey="id" #dt [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" [globalFilterFields]="['id','empresa','identificador','lanHora','lanData','status']">

          <ng-template pTemplate="header">
            <tr>
              <th style="width:12%" >Campo</th>
              <th style="width:12%" >Variável</th>
              <th style="width:12%" >Valor</th>
              <th style="width:12%" >Status</th>
              <th style="width:12%" >Mensagem</th>
              <th style="width:12%" >Dt Integrado</th>
              <th style="width:12%" >Dt Recebimento</th>
              <th style="width:12%" >Dt Atualizacao</th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-atributo>
            <tr>
              <td>{{ atributo.nomeCampo }}</td>
              <td>{{ atributo.variavel }}</td>
              <td>{{ atributo.valor }}</td>
              <td><p-tag [severity]="getSeverity(atributo.status)">{{ atributo.status }}</p-tag></td>
              <td>{{ atributo.mensagem }}</td>
              <td>{{ atributo.dtIntegrado | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ atributo.dtCriado | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ atributo.dtAtualizacao | date: 'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </ng-template>
        </p-table>

      <div class="field">

      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="Fechar"
        icon="pi pi-times"
        [text]="true"
        (onClick)="esconderDialogo()" />
    </ng-template>
  </p-dialog>

</div>

